import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {InputNumber} from "primereact/inputnumber";
import {useRef, useState} from "react";
import {Slot} from "../../data/Slot";
import {Toast} from "primereact/toast";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";

const now = new Date();
now.setMinutes(0);
const nowPlus1 = new Date(now.getTime());
nowPlus1.setHours(now.getHours() + 1);

function SlotCreation({onSlotCreated}: { onSlotCreated(slot: Slot): void }) {
    const [slot, setSlot] = useState<Slot>(new Slot());
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const toast = useRef<Toast>(null);

    const showSuccess = () => {
        toast.current!.show({
            severity: "success",
            summary: "Erfolg",
            detail: "Termin erfolgreich erstellt!",
            life: 3000,
        });
    };

    const showError = () => {
        toast.current!.show({
            severity: "error",
            summary: "Error",
            detail: "Ein Fehler ist aufgetreten...",
            life: 3000,
        });
    };

    function postSlot() {
        const start = new Date(
            Date.UTC(
                slot.startDateTime.getFullYear(),
                slot.startDateTime.getMonth(),
                slot.startDateTime.getDate(),
            ),
        );
        start.setUTCHours(slot.startDateTime.getUTCHours());
        start.setUTCMinutes(slot.startDateTime.getUTCMinutes());

        const end = new Date(
            Date.UTC(
                slot.endDateTime.getFullYear(),
                slot.endDateTime.getMonth(),
                slot.endDateTime.getDate(),
            ),
        );
        end.setUTCHours(slot.endDateTime.getUTCHours());
        end.setUTCMinutes(slot.endDateTime.getUTCMinutes());

        async function post() {
            setIsLoading(true);

            try {
                const response = await fetch(
                    `/api/slot/entries`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        credentials: "include",
                        body: JSON.stringify({
                            startDateTime: start.toISOString(),
                            endDateTime: end.toISOString(),
                            capacity: slot.capacity,
                            comment: slot.comment,
                            disabled: slot.disabled,
                        }),
                    },
                );
                const resData = await response.json();

                const newSlot = Object.assign(new Slot(), resData);
                newSlot.startDateTime = new Date(newSlot.startDateTime);
                newSlot.endDateTime = new Date(newSlot.endDateTime);

                onSlotCreated(newSlot);
                setSlot(new Slot());
                showSuccess();
            } catch {
                showError();
            }

            setIsLoading(false);
        }

        post();
    }

    return (
        <div>
            <div className="p-fluid mb-5 mt-3">
        <span className="p-float-label">
          <InputNumber
              id="capacity"
              value={slot.capacity}
              onValueChange={(e) => setSlot({...slot, capacity: e.value || 10})}
              min={1}
              showButtons
              className="w-full"
          />
          <label htmlFor="capacity">Plätze</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <Calendar
              id="startDateTime"
              value={slot.startDateTime}
              onChange={(e) => {
                  const newStartDateTime = e.value as Date;
                  const newEndDateTime = new Date(
                      newStartDateTime.getTime() + 2.5 * 60 * 60 * 1000,
                  );
                  setSlot({
                      ...slot,
                      startDateTime: newStartDateTime,
                      endDateTime: newEndDateTime,
                  });
              }}
              showTime
              hourFormat="24"
              className="w-full"
          />
          <label htmlFor="startDateTime">Startzeit</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <Calendar
              id="endDateTime"
              value={slot.endDateTime}
              onChange={(e) => setSlot({...slot, endDateTime: e.value as Date})}
              showTime
              hourFormat="24"
              className="w-full"
          />
          <label htmlFor="endDateTime">Endzeit</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <InputText
              value={slot.comment}
              onChange={(e) => setSlot({...slot, comment: e.target.value})}
              id="comment"
              className="w-full"
          />
          <label htmlFor="comment">Kommentar</label>
            
        </span></div>

            <div className="p-fluid mb-5">
                <span className="p-float-label">
                    <Checkbox value={"test"} checked={slot.disabled}
                              onChange={(e) => setSlot({...slot, disabled: e.target.checked!})}/>
                    <label className="ml-3">Gesperrt</label>
                </span>
            </div>
            <Button
                loading={isLoading}
                disabled={
                    slot.capacity === null ||
                    slot.startDateTime === null || slot.startDateTime === undefined ||
                    slot.endDateTime === null || slot.endDateTime === undefined
                }
                label="Erstellen"
                onClick={postSlot}
                className="w-full"
            />
            <Toast ref={toast}/>
        </div>
    );
}

export default SlotCreation;
